import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { BaseUrl } from "../common/config";
import { http } from "../helper";
import CommonAlert from "../common/Commonalert";
import ShowAlert from "../common/Showalert";
import Select from "react-select";
//import { canAction } from "../common/permissionhelper";
//const MODULE = 'manage_masterentry';
const HoAccountEdit = () => {
  const { id } = useParams(); // ID of the record to edit
  const navigate = useNavigate();
  //   const canView = canAction(MODULE, 'view');
  //   const canEdit = canAction(MODULE, 'edit');
  //   const isReadOnly = !canEdit;
  const [accountCodeOptions, setAccountCodeOptions] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState("");
  const [originalCode, setOriginalCode] = useState("");
  const [restrictedCodeSet, setRestrictedCodeSet] = useState(new Set());
  const [inputValue, setInputValue] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true); 
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_ho")
  ) {
    window.location.href = "/unauthorized";
  }
//   // Redirect if no view permission
//   useEffect(() => {
//     if (!canView) navigate("/restrictedaccountcode/accountcode");
//   }, [canView]);

  // Fetch all account codes & restricted codes
  useEffect(() => {
    const fetchCodes = async () => {
      setIsLoading(true);
      try {
        const [allRes, restrictedRes, chefsRes, hoCodeRes] = await Promise.all([
          http.get(`${BaseUrl}admin/account`),
          http.get(`${BaseUrl}admin/hoaccountlist`),
          http.get(`${BaseUrl}admin/getchefs`),
          http.get(`${BaseUrl}admin/hoaccountcodelist`)
        ]);
        const allCodes = allRes.data.data || [];
        /* HO ACCOUNT LIST */
        const restrictedCodes = restrictedRes.data.data || [];
        const restrictedSet = new Set(
          restrictedCodes.map(item => item.accountCode?.toLowerCase())
        );
        setRestrictedCodeSet(restrictedSet);
        /* CHEF ACCOUNTS */
        const chefAccountSet = new Set();
        const chefPrimaryCodeSet = new Set();
        (chefsRes.data.data || []).forEach(group => {
          if (group.primaryAccount?.accountCode) {
            chefPrimaryCodeSet.add(
              group.primaryAccount.accountCode.toLowerCase()
            );
          }
        });
        /* HO ACCOUNT CODE LIST */
        const hoAccountCodeSet = new Set(
          (hoCodeRes.data.data || []).map(
            item => item.accountCode?.toLowerCase()
          )
        );
        /* -------- FINAL FILTER (EDIT SAFE) -------- */
        const filteredCodes = allCodes.filter(item => {
          const code = item.accountCode?.toLowerCase();
          // Always allow the original selected code
          if (code === originalCode?.toLowerCase()) return true;
          return (
            item.accountWebSiteAccess?.toLowerCase() === 'yes' &&
            item.accountStatus?.toLowerCase() === 'active' &&
            !restrictedSet.has(code) &&
            !chefPrimaryCodeSet.has(code) &&
            !hoAccountCodeSet.has(code)
          );
        });
        setAccountCodeOptions(filteredCodes);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    };
    fetchCodes();
  }, [originalCode]);
  // Fetch existing account codes for editing
  useEffect(() => {
    const fetchExisting = async () => {
      setIsLoading(true);
      try {
        const res = await http.get(`${BaseUrl}admin/hoaccount/${id}`);
        if (res.data.success && res.data.data) {
          // Wrap single accountCode in an array
          const existingCode = res.data.data.accountCode || "";
          setSelectedCodes(existingCode);
          setOriginalCode(existingCode);
        } else {
          setErrorPopup(true);
          setIsLoading(false);
          setErrorMessage("Failed to fetch account code details.");
        }
      } catch (err) {
        setErrorPopup(true);
        setIsLoading(false);
        setErrorMessage("Something went wrong while fetching data.");
        console.log(err);
      }
    };
    if (id) fetchExisting();
  }, [id]);

  const handleCancel = () => navigate("/headoffice/account");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputValue("");

    //if (isReadOnly) return;

    if (!selectedCodes || selectedCodes.trim() === "") {
      setErrMessage("Please select an account code.");
      return;
    }
    const newCodeLower = selectedCodes.trim().toLowerCase();
    const originalLower = (originalCode || "").trim().toLowerCase();
    // If the newly selected code is restricted and is different from original, show error
    if (restrictedCodeSet.has(newCodeLower) && newCodeLower !== originalLower) {
      // Show popup and STOP the update
      setErrorPopup(true);
      setErrorMessage(`Account code "${selectedCodes}" is already restricted.`);
      return;
    }

    const payload = { id, selectedAccountCodes: [selectedCodes] };

    try {
      const res = await http.put(`${BaseUrl}admin/hoaccount`, payload);
      if (res.data.success) {
        setAlertPopup(true);
        setIsLoading(false);
        setAlertMessage("Account Code updated successfully");
        setTimeout(() => navigate("/headoffice/account"), 1500);
      } else {
        setErrorPopup(true);
        setErrorMessage("Failed to update account code(s)");
      }
    } catch (err) {
      console.log(err);
      const backendMsg =
        err?.response?.data?.message || "Something went wrong while updating.";
      setErrorPopup(true);
      setErrorMessage(backendMsg);
    }
  };

  const customNoOptionsMessage = () => {
    const input = inputValue.trim().toLowerCase();
    if (restrictedCodeSet.has(input)) return null;
    if (input.length > 0) return "No options";
    return null;
  };

  return (
    <>
      {errorPopup && <ShowAlert title="Alert" message={errorMessage} />}
      {alertPopup && <CommonAlert title="Alert" message={alertMessage} />}
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">
                {/* {canEdit ? "Edit Account Code" : "View Account Code"} */}
                Edit Account Code
              </h1>
              <div className="right-table-outer-wrap">
                {isLoading  ? (
                  <div className='loading-buffer'></div>
              ):(
                <form
                  className="addform form-container-xs"
                  onSubmit={handleSubmit}
                >
                  <div className="input-field col-1">
                    <label>Account Code</label>
                    <Select
                      isMulti={false}
                      closeMenuOnSelect={true}
                      noOptionsMessage={customNoOptionsMessage}
                      // Select expects an object {value,label} for single select
                      value={
                        selectedCodes
                          ? { value: selectedCodes, label: selectedCodes }
                          : null
                      }
                      onChange={(selectedOption) => {
                        const code = selectedOption ? selectedOption.value : "";
                        setSelectedCodes(code);
                        setInputValue("");
                        if (code) setErrMessage("");
                      }}
                      onInputChange={(value, { action }) => {
                        if (action === "input-change") {
                          setInputValue(value);
                          if (
                            restrictedCodeSet.has(value.trim().toLowerCase())
                          ) {
                            setErrMessage(
                              `Account code "${value}" is already restricted`
                            );
                            setTimeout(() => {
                              setErrMessage("");
                              setInputValue("");
                            }, 1000);
                          }
                        }
                      }}
                      onBlur={() => setInputValue("")}
                      inputValue={inputValue}
                      options={accountCodeOptions.map((opt) => ({
                        value: opt.accountCode,
                        label: opt.accountCode,
                      }))}
                      className="form-control"
                      placeholder="Select Account Code"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          position: "relative",
                          zIndex: 2,
                        }),
                      }}
                      //isDisabled={isReadOnly}
                    />
                    {errMessage && (
                      <div className="error-msg">{errMessage}</div>
                    )}
                  </div>
                  {/* {!isReadOnly && <button type="submit">Update</button>} */}
                  <button type="submit">Update</button>
                  &nbsp;&nbsp;
                  <button type="button" onClick={handleCancel}>
                    Cancel
                  </button>
                </form>
              )}
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default HoAccountEdit;
